"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageName = void 0;
var PageName;
(function (PageName) {
    PageName["MAIN"] = "\uBA54\uC778 \uD398\uC774\uC9C0";
    PageName["PRODUCT"] = "\uC81C\uD488";
    PageName["SERVICE"] = "\uC11C\uBE44\uC2A4";
    PageName["INTRODUCTION"] = "\uD68C\uC0AC\uC18C\uAC1C";
    PageName["INVESTMENT"] = "\uD22C\uC790\uC815\uBCF4";
    PageName["ADVERTISEMENT"] = "\uC0AC\uC774\uBC84\uD64D\uBCF4";
    PageName["RECRUITMENT"] = "\uCC44\uC6A9\uC815\uBCF4";
})(PageName || (exports.PageName = PageName = {}));
